import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    batteryObject: null,
    batteryValue: null,
    batteryState: "",
    showLowBatteryMsg: false,
    isLowBatteryMsgSent: false,
    isHighBatteryMsgSent: false,
    isLocalDeviceBatteryLow: false,
    lowBatteryParticipanteId: "",
    localNetworkTypeTitle: "",
    isNetworkUnstablePopupVisible: false,
    networkUnstableMessage: "",
    isLocalUserOffline: false,
    isLocalUserReconnecting: false,
};

const batteryAndNetworkInfoReducerSlice = createSlice({
    name: "batteryAndNetworkInfoReducer",
    initialState,
    reducers: {
        setBatteryInfoObject(state, action) {
            state.batteryObject = action.payload;
        },
        setBatteryValue(state, action) {
            state.batteryValue = action.payload;
        },
        setBatteryState(state, action) {
            state.batteryState = action.payload;
        },
        setShowLowBatteryMsg(state, action) {
            state.showLowBatteryMsg = action.payload;
        },
        setIsLowBatteryMsgSent(state, action) {
            state.isLowBatteryMsgSent = action.payload;
        },
        setIsHighBatteryMsgSent(state, action) {
            state.isHighBatteryMsgSent = action.payload;
        },
        setIsLocalDeviceBatteryLow(state, action) {
            state.isLocalDeviceBatteryLow = action.payload;
        },
        setLowBatteryParticipanteId(state, action) {
            state.lowBatteryParticipanteId = action.payload;
        },
        setLocalNetworkTypeTitle(state, action) {
            state.localNetworkTypeTitle = action.payload;
        },
        setIsNetworkUnstablePopupVisible(state, action) {
            state.isNetworkUnstablePopupVisible = action.payload;
        },
        setNetworkUnstableMessage(state, action) {
            state.networkUnstableMessage = action.payload;
        },
        setIsLocalUserOffline(state, action) {
            state.isLocalUserOffline = action.payload;
        },
        setIsLocalUserReconnecting(state, action) {
            state.isLocalUserReconnecting = action.payload;
        },
        resetBatteryAndNetworkInfoReducer() {
            return initialState;
        },
    },
});

export const {
    setBatteryInfoObject,
    setBatteryValue,
    setBatteryState,
    resetBatteryAndNetworkInfoReducer,
    setShowLowBatteryMsg,
    setIsLowBatteryMsgSent,
    setIsHighBatteryMsgSent,
    setIsLocalDeviceBatteryLow,
    setLowBatteryParticipanteId,
    setLocalNetworkTypeTitle,
    setIsNetworkUnstablePopupVisible,
    setNetworkUnstableMessage,
    setIsLocalUserOffline,
    setIsLocalUserReconnecting,
} = batteryAndNetworkInfoReducerSlice.actions;
export default batteryAndNetworkInfoReducerSlice.reducer;
